export const environment = {
  production: true,
  apiRoot: `https://api.eceos.cloud/v1/`,
  gaCode: 'G-LCN6SXQMGS'
};
